import { Role } from "./role";
import { AreaFuncionalGAFU } from "./area-funcional-gafu";
export class User {
    id: string;
    username: string;
    password: string;
    nombreCompleto: string;
    roles: Role[];
    areasFuncionales: AreaFuncionalGAFU[];
}